import { render, staticRenderFns } from "./remodel-add-or-update.vue?vue&type=template&id=42f32f9f&"
import script from "./remodel-add-or-update.vue?vue&type=script&lang=js&"
export * from "./remodel-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports